import React from 'react';
import { withLocale } from '../hocs/withLocale';

export const PrivacyPolicy = withLocale(({ currentLanguage }) => {
  switch (currentLanguage) {
    case 'uk_UA':
      return (
        <div style={{ margin: 10 }}>
          <h1>
            <span>Політика конфіденційності</span>
          </h1>
          <p>
            <span>Дата набрання чинності: 16 червня 2019 року</span>
          </p>
          <p className="c1 c6">
            <span className="c0"></span>
          </p>
          <p className="c1">
            <span className="c0">
              Voopty ("ми", "ми", або "наш") працює на веб-сайті https://www.voopty.com/ (далі - "Сервіс").
            </span>
          </p>
          <p className="c1">
            <span className="c0">
              Ця сторінка інформує Вас про нашу політику щодо збору, використання та розкриття персональних даних, коли
              Ви користуєтеся нашим Сервісом, та вибір, пов'язаний з цими даними.
            </span>
          </p>
          <p className="c1">
            <span>
              Ми використовуємо ваші дані для надання та покращення Сервісу. Користуючись послугою, ви погоджуєтеся на
              збір та використання інформації відповідно до цієї політики. Якщо в цій Політиці конфіденційності не
              визначено інше, терміни, що використовуються в цій Політиці конфіденційності, мають такі ж значення, як і
              в наших Загальних положеннях та умовах, доступних за адресою{' '}
            </span>
            <span>https://www.voopty.com/</span>
            <sup>
              <a href="#cmnt1" id="cmnt_ref1">
                [a]
              </a>
            </sup>
          </p>
          <h2 className="c4" id="h.fx3y36r1zii7">
            <span className="c9">Визначення</span>
          </h2>
          <ul className="c8 lst-kix_rskoezreub4b-0 start">
            <li className="c1 c2">
              <span className="c0">Сервіс - це https: //www.voopty .com / веб-сайт, керований Voopty</span>
            </li>
            <li className="c1 c2">
              <span className="c0">
                Особисті дані - це дані про живу особу, яка може бути ідентифікована з цих даних (або з тих та інших
                відомостей, які є в нашому розпорядженні або можуть бути у нас у власності).
              </span>
            </li>
            <li className="c1 c2">
              <span className="c0">
                Дані про використання - це дані, які збираються автоматично або з використанням Сервісу, або з самої
                сервісної інфраструктури (наприклад, тривалість відвідування сторінки).
              </span>
            </li>
            <li className="c1 c2">
              <span className="c0">
                Cookies - це невеликі файли, що зберігаються на вашому пристрої (комп'ютері або мобільному пристрої).
              </span>
            </li>
            <li className="c1 c2">
              <span className="c0">
                Контролер даних - фізична або юридична особа, яка (самостійно або спільно з іншими особами) визначає
                цілі та спосіб, в якому будь-яка особиста інформація обробляється, або має бути оброблена.
                <br />
                Для цілей цієї Політики конфіденційності ми є Контролером даних Ваших Персональних Даних.
              </span>
            </li>
            <li className="c1 c2">
              <span className="c0">
                Обробник даних (або постачальник послуг) означає будь-яку фізичну, або юридичну особу, яка обробляє дані
                від імені контролера даних.
                <br />
                Ми можемо використовувати послуги різних постачальників послуг для більш ефективної обробки ваших даних.
              </span>
            </li>
            <li className="c1 c2">
              <span className="c0">
                Суб'єкт даних (або Користувач) - це будь-яка жива особа, яка користується нашою послугою і є предметом
                персональних даних.
              </span>
            </li>
          </ul>
          <h2 className="c4" id="h.5xocmgqoiq64">
            <span className="c9">Збір інформації та використання</span>
          </h2>
          <p className="c1">
            <span className="c0">
              Ми збираємо декілька різних типів інформації для різних цілей, щоб надати та покращити наш Сервіс для Вас.
            </span>
          </p>
          <h3 className="c5" id="h.amhj33b2c5i9">
            <span className="c3">Типи зібраних даних</span>
          </h3>
          <h4 className="c13" id="h.n11jofm5p55j">
            <span className="c14">Особисті дані</span>
          </h4>
          <p className="c1">
            <span className="c0">
              Під час користування нашим Сервісом, ми можемо попросити Вас надати нам певну особисту інформацію, яка
              може бути використана для зв'язку або ідентифікації ("Особисті дані"). Інформація, що ідентифікує особу,
              може включати, але не обмежуватись наступним:
            </span>
          </p>
          <p className="c1 c6">
            <span className="c0"></span>
          </p>
          <ul className="c8 lst-kix_nmr2jirr64ll-0 start">
            <li className="c1 c2">
              <span className="c0">Адреса електронної пошти</span>
            </li>
            <li className="c1 c2">
              <span className="c0">Ім'я та прізвище</span>
            </li>
            <li className="c1 c2">
              <span className="c0">Номер телефону</span>
            </li>
            <li className="c1 c2">
              <span className="c0">Адреса, штат, провінція, ZIP / Поштовий код, Місто</span>
            </li>
            <li className="c1 c2">
              <span className="c0">Cookies та дані про використання</span>
            </li>
          </ul>
          <p className="c1 c6">
            <span className="c0"></span>
          </p>
          <p className="c1">
            <span className="c0">
              Ми можемо використовувати ваші особисті дані, щоб зв'язатися з вами за допомогою інформаційних бюлетенів,
              маркетингових матеріалів з ціллю надати інформацію, яка може вас зацікавити. Ви можете відмовитися від
              отримання будь-яких, або всіх цих повідомлень від нас, звернувшись до нас.
            </span>
          </p>
          <h4 className="c13" id="h.pvn88gc78nme">
            <span className="c14">Дані про використання</span>
          </h4>
          <p className="c1">
            <span className="c0">
              Ми також можемо збирати інформацію про доступ до Сервісу та її використання ("Дані про використання"). Ці
              дані про використання можуть містити таку інформацію, як адреса Інтернет-протоколу комп'ютера (наприклад,
              IP-адреса), тип браузера, версія барузера, сторінки нашого Сервіса, які ви відвідуєте, час і дату вашого
              відвідування, час, витрачений на ці сторінки, унікальний ідентифікатори пристроїв та інші діагностичні
              дані.
            </span>
          </p>
          <h4 className="c13" id="h.r5d2p3uqjgvn">
            <span className="c14">Дані про місцезнаходження</span>
          </h4>
          <p className="c1">
            <span className="c0">
              Ми можемо використовувати та зберігати інформацію про ваше місцезнаходження, якщо ви даєте нам дозвіл на
              це ("Дані про місцезнаходження"). Ми використовуємо ці дані для забезпечення функцій нашого Сервіса, для
              покращення та налаштування нашого Сервіса.
            </span>
          </p>
          <p className="c1">
            <span className="c0">
              Можна вмикати, або вимикати сервіси визначення місцезнаходження, коли ви користуєтеся нашим Сервісом в
              будь-який час за допомогою налаштувань вашого пристрою.
            </span>
          </p>
          <h4 className="c13" id="h.mi0p5721elhc">
            <span className="c14">Відстеження та дані cookie</span>
          </h4>
          <p className="c1">
            <span className="c0">
              Ми використовуємо файли cookie та подібні технології відстеження для відстеження діяльності нашого Сервіса
              і зберігаємо певну інформацію.
            </span>
          </p>
          <p className="c1">
            <span className="c0">
              Cookies - це файли з невеликою кількістю даних, які можуть включати анонімний унікальний ідентифікатор.
              Файли cookie надсилаються до веб-переглядача з веб-сайту та зберігаються на пристрої. Також
              використовуються інші технології відстеження, такі як маяки, теги та скрипти для збору та відстеження
              інформації, а також для вдосконалення та аналізу нашого Сервіса.
            </span>
          </p>
          <p className="c1">
            <span className="c0">
              Ви можете відмовитися від всіх файлів cookie або вказати, коли надсилається файл cookie, вказвши
              відповідні налаштування свого браузеру. Однак, якщо ви не приймаєте файли cookie, ви не зможете
              використовувати деякі частини нашого Сервіса.
            </span>
          </p>
          <p className="c1">
            <span className="c0">Приклади файлів cookie, які ми використовуємо:</span>
          </p>
          <ul className="c8 lst-kix_c2t6h8m0hunk-0 start">
            <li className="c1 c2">
              <span className="c11">Session Cookies.</span>
              <span className="c0">&nbsp;Ми використовуємо Session Cookies для керування нашим Сервісом.</span>
            </li>
            <li className="c1 c2">
              <span className="c11">Preference Cookies.</span>
              <span className="c0">
                &nbsp;Ми використовуємо Preference Cookies для запам'ятовування Ваших уподобань та різних параметрів.
              </span>
            </li>
            <li className="c1 c2">
              <span className="c11">Security Cookies.</span>
              <span className="c0">&nbsp;Ми використовуємо Security Cookies для цілей безпеки.</span>
            </li>
          </ul>
          <h2 className="c4" id="h.5jlvpqhhfp9i">
            <span className="c9">Використання даних</span>
          </h2>
          <p className="c1">
            <span className="c0">Voopty використовує зібрані дані для різних цілей:</span>
          </p>
          <ul className="c8 lst-kix_q1t6q3ncm7z8-0 start">
            <li className="c1 c2">
              <span className="c0">Надання та підтримка нашого Сервіса;</span>
            </li>
            <li className="c1 c2">
              <span className="c0">Щоб повідомити Вас про зміни в нашому Сервісі;</span>
            </li>
            <li className="c1 c2">
              <span className="c0">
                Щоб дозволити Вам брати участь в інтерактивних функціях нашого Сервіса, коли Ви вирішите зробити це;
              </span>
            </li>
            <li className="c1 c2">
              <span className="c0">Щоб забезпечити підтримку клієнтів;</span>
            </li>
            <li className="c1 c2">
              <span className="c0">Щоб зібрати аналіз або цінну інформацію, щоб ми могли покращити наш Сервіс;</span>
            </li>
            <li className="c1 c2">
              <span className="c0">Щоб контролювати використання нашого Сервіса;</span>
            </li>
            <li className="c1 c2">
              <span className="c0">Для виявлення, запобігання та вирішення технічних питань;</span>
            </li>
            <li className="c1 c2">
              <span className="c0">
                Щоб надати вам новини, спеціальні пропозиції та загальну інформацію про інші товари, послуги та події,
                які ми пропонуємо, подібні до тих, які ви вже придбали або запитали, в тому випадку, якщо ви не обрали
                раніше не отримувати таку інформацію.
              </span>
            </li>
          </ul>
          <h2 className="c4" id="h.cqsdzp1v16vs">
            <span className="c9">
              Правова основа для обробки персональних даних відповідно до Загального регламенту щодо захисту даних
              (GDPR)
            </span>
          </h2>
          <p className="c1">
            <span className="c0">
              Якщо ви перебуваєте з Європейської Економічної Зоні (ЄЕЗ), правова база для збору використання особистої
              інформації, описаної в цій Політиці конфіденційності, залежить від особистих даних, які ми збираємо, та
              конкретного контексту, в якому ми збираємося викладайте його.
            </span>
          </p>
          <p className="c1">
            <span className="c0">Voopty може обробляти ваші особисті дані тому що:</span>
          </p>
          <ul className="c8 lst-kix_s4lko0wzby03-0 start">
            <li className="c1 c2">
              <span className="c0">ми повинні виконати контракт з вами;</span>
            </li>
            <li className="c1 c2">
              <span className="c0">ви надали нам дозвіл зробити це;</span>
            </li>
            <li className="c1 c2">
              <span className="c0">обробка в наших законних інтересах і не перевизначена правами;</span>
            </li>
            <li className="c1 c2">
              <span className="c0">для цілей обробки платежів;</span>
            </li>
            <li className="c1 c2">
              <span className="c0">з метою дотримання закону.</span>
            </li>
          </ul>
          <h2 className="c4" id="h.sc3aqa1afgeg">
            <span className="c9">Утримання Даних</span>
          </h2>
          <p className="c1">
            <span className="c0">
              Voopty зберігатимуть Ваші Персональні Дані лише протягом часу, необхідного для цілей, викладених у цій
              Політиці конфіденційності. Ми зберігатимемо і використовуватимемо Ваші Персональні Дані в межах,
              необхідних для виконання наших юридичних зобов'язань (наприклад, якщо ми повинні зберегти Ваші дані для
              дотримання чинного законодавства), вирішити суперечки та забезпечити виконання наших юридичних угод і
              політик.
            </span>
          </p>
          <p className="c1">
            <span className="c0">
              Voopty також зберігатиме дані про використання для цілей внутрішнього аналізу. Дані про використання
              зазвичай зберігаються протягом більш короткого періоду часу, за винятком випадків, коли ці дані
              використовуються для посилення безпеки або для поліпшення функціональності нашого Сервіса, або ми юридично
              зобов'язані зберігати ці дані на більш тривалий час.
            </span>
          </p>
          <h2 className="c4" id="h.nnnk0m34a01c">
            <span className="c9">Передача даних</span>
          </h2>
          <p className="c1">
            <span className="c0">
              Ваша інформація, включаючи особисті дані, може бути передана на комп'ютери, розташовані за межами вашої
              держави, провінції, країни або іншої урядової юрисдикції, і зберігатися на них, коли закони про захист
              даних можуть відрізнятися від законів вашої юрисдикції.
            </span>
          </p>
          <p className="c1">
            <span className="c0">
              Якщо ви перебуваєте за межами Сполучених Штатів і надаєте нам інформацію, зверніть увагу, що ми передаємо
              дані, включаючи особисті дані, до Сполучених Штатів і обробляємо їх там.
            </span>
          </p>
          <p className="c1">
            <span className="c0">
              Ваша згода на цю політику конфіденційності, за якою ви подаєте таку інформацію, є вашою згодою на цю
              передачу.
            </span>
          </p>
          <p className="c1">
            <span className="c0">
              Компанія Voopty буде вживати всіх необхідних заходів для забезпечення надійної обробки Ваших даних і
              відповідно до цієї Політики конфіденційності, а перенесення Ваших Персональних даних не відбудеться в
              організацію або країну, якщо не буде забезпечено належного контролю, включаючи безпеку дані та іншу
              особисту інформацію.
            </span>
          </p>
          <h2 className="c4" id="h.y3uf71x29l1">
            <span className="c9">Розкриття інформації про</span>
          </h2>
          <h3 className="c5" id="h.tltfafywcenw">
            <span className="c3">бізнес-операції</span>
          </h3>
          <p className="c1">
            <span className="c0">
              Якщо компанія Voopty бере участь у злитті, придбанні або продажу активів, ваші особисті дані можуть бути
              передані. Ми надішлемо повідомлення до того, як Ваші Персональні Дані будуть передані і стануть предметом
              іншої політики конфіденційності.
            </span>
          </p>
          <h3 className="c5" id="h.oni31inuh9mi">
            <span className="c3">Розкриття інформації для правоохоронних органів</span>
          </h3>
          <p className="c1">
            <span className="c0">
              За певних обставин, Voopty може вимагати розкриття Ваших Персональних даних, якщо це вимагається законом
              або у відповідь на дійсні запити органів державної влади (наприклад, суд або державний орган).
            </span>
          </p>
          <h3 className="c5" id="h.nc9f4bkdqtmy">
            <span className="c3">Юридичні вимоги</span>
          </h3>
          <p className="c1">
            <span className="c0">
              Voopty може розкрити ваші особисті дані в сумлінному припущеннітещо така дія необхідна:
            </span>
          </p>
          <ul className="c8 lst-kix_50hpoaxqw86w-0 start">
            <li className="c1 c2">
              <span className="c0">Відповідно до юридичним зобов'язанням</span>
            </li>
            <li className="c1 c2">
              <span className="c0">захищати і відстоювати права або власність Voopty</span>
            </li>
            <li className="c1 c2">
              <span className="c0">Для запобігання або розслідування можливих порушень в зв'язку з Сервісом</span>
            </li>
            <li className="c1 c2">
              <span className="c0">щоб захистити особисту безпеку користувачів Сервісу, або громадськості</span>
            </li>
            <li className="c1 c2">
              <span className="c0">Захист від юридичної відповідальності</span>
            </li>
          </ul>
          <h2 className="c4" id="h.tq23cwoanl8b">
            <span className="c9">Безпека даних</span>
          </h2>
          <p className="c1">
            <span className="c0">
              Безпека Ваших даних важлива для нас, але пам'ятайте, що жоден спосіб передачі через Інтернет або метод
              електронного зберігання не є 100% безпечним. Хоча ми прагнемо використовувати комерційно прийнятні засоби
              для захисту ваших особистих даних, ми не можемо гарантувати його абсолютну безпеку.
            </span>
          </p>
          <h2 className="c4" id="h.8s1dmn35btsh">
            <span className="c9">
              Наша політика щодо сигналів "Не відстежувати" згідно із Законом про захист онлайн (CalOPPA) в Каліфорнії
            </span>
          </h2>
          <p className="c1">
            <span className="c0">
              Ми не підтримуємо Do Not Track ("DNT"). Не відстежувати - це переваги, які можна встановити у
              веб-переглядачі, щоб повідомити веб-сайти, які ви не хочете відстежувати.
            </span>
          </p>
          <p className="c1">
            <span className="c0">
              Можна ввімкнути або вимкнути функцію "Не відстежувати", перейшовши на сторінку "Налаштування" або
              "Налаштування" веб-переглядача.
            </span>
          </p>
          <h2 className="c4" id="h.z43fl9ctsazm">
            <span className="c9">Ваші права на захист даних згідно з Регламентом загального захисту даних (GDPR)</span>
          </h2>
          <p className="c1">
            <span className="c0">
              Якщо ви є резидентом Європейської економічної зони (ЄЕЗ), у вас є певні права захисту даних. Компанія
              Voopty прагне вжити розумних заходів, щоб дозволити вам виправити, змінити, видалити або обмежити
              використання Ваших персональних даних.
            </span>
          </p>
          <p className="c1">
            <span className="c0">
              Якщо ви хочете бути в курсі того, що особисті дані, які ми зберігаємо про вас, і якщо ви хочете, щоб вони
              були видалені з наших систем, будь ласка, зв'яжіться з нами.
            </span>
          </p>
          <p className="c1">
            <span className="c0">За певних обставин ви маєте такі права захисту даних:</span>
          </p>
          <ul className="c8 lst-kix_3h7w6h6l2vfu-0 start">
            <li className="c1 c2">
              <span className="c0">
                право на доступ, оновлення або видалення інформації, яку ми маємо про вас. Коли це стане можливим, ви
                можете отримати доступ, оновити або подати запит на видалення ваших особистих даних безпосередньо в
                розділі налаштувань облікового запису. Якщо ви не можете виконати ці дії самостійно, зв'яжіться з нами,
                щоб допомогти вам.
              </span>
            </li>
            <li className="c1 c2">
              <span className="c0">
                Право на виправлення. Ви маєте право на виправлення вашої інформації, якщо ця інформація є неточною або
                неповною.
              </span>
            </li>
            <li className="c1 c2">
              <span className="c0">
                Право на об'єкт. Ви маєте право заперечувати нашу обробку ваших особистих даних.
              </span>
            </li>
            <li className="c1 c2">
              <span className="c0">
                Право обмеження. Ви маєте право вимагати, щоб ми обмежили обробку вашої особистої інформації.
              </span>
            </li>
            <li className="c1 c2">
              <span className="c0">
                Право на портативність даних. Ви маєте право отримати копію інформації, яку ми маємо про вас, у
                структурованому, машиночитаемому і широко використовуваному форматі.
              </span>
            </li>
            <li className="c1 c2">
              <span className="c0">
                Право на відкликання згоди. Ви також маєте право відкликати свою згоду в будь-який час, коли Voopty
                покладається на вашу згоду на обробку вашої особистої інформації.
              </span>
            </li>
          </ul>
          <p className="c1">
            <span className="c0">
              Зауважте, що ми можемо попросити вас підтвердити свою особу, перш ніж відповідати на такі запити.
            </span>
          </p>
          <p className="c1">
            <span className="c0">
              Ви маєте право подати скаргу до органу захисту даних про нашу збір та використання Ваших персональних
              даних. Для отримання додаткової інформації зверніться до місцевого органу захисту даних у Європейській
              економічній зоні (ЄЕЗ).
            </span>
          </p>
          <h2 className="c4" id="h.vt4esr5b88hn">
            <span className="c9">Постачальники послуг</span>
          </h2>
          <p className="c1">
            <span className="c0">
              Ми можемо залучати компанії та фізичних осіб третіх осіб для сприяння нашому Сервісу ("Постачальники
              послуг"), надавати Сервіс від нашого імені, виконувати послуги, пов'язані з обслуговуванням, або
              допомагати нам у аналізі використання Сервісу.
            </span>
          </p>
          <p className="c1">
            <span className="c0">
              Ці треті сторони мають доступ до Ваших Персональних даних тільки для виконання цих завдань від нашого
              імені і зобов'язані не розголошувати або використовувати її для будь-яких інших цілей.
            </span>
          </p>
          <h3 className="c5" id="h.rqoneltegftt">
            <span className="c3">Аналітика</span>
          </h3>
          <p className="c1">
            <span className="c0">
              Ми можемо використовувати постачальників послуг третьої сторони для моніторингу та аналізу використання
              нашого Сервісу.
            </span>
          </p>
          <ul className="c8 lst-kix_8324hhdwt53y-0 start">
            <li className="c1 c2">
              <span>
                Google Analytics
                <br />
                Google Analytics - це сервіс веб-аналітики, яка пропонує Google, яка відстежує та повідомляє про трафік
                веб-сайту. Google використовує зібрані дані для відстеження та контролю використання нашого Сервіса. Ці
                дані надаються спільно з іншими сервісами Google. Google може використовувати зібрані дані для
                контекстуалізації та персоналізації оголошень власної рекламної мережі.
                <br />
                Ви можете відмовитися від того, що ваша діяльність у Сервісі доступна для Google Analytics, встановивши
                дотаток до браузера Google Analytics opt-out. Цей додаток забороняє JavaScript Analytics (ga.js,
                analytics.js і dc.js) обмінюватися інформацією з Google Analytics щодо активності відвідувань.
                <br />
                Щоб отримати докладнішу інформацію про політику Google щодо конфіденційності, відвідайте веб-сторінку
                Політики конфіденційності та умов Google:{' '}
              </span>
              <span className="c12">
                <a
                  className="c16"
                  href="https://www.google.com/url?q=https://policies.google.com/privacy?hl%3Den&amp;sa=D&amp;ust=1562951790326000"
                >
                  https://policies.google.com/privacy?hl=uk
                </a>
              </span>
            </li>
          </ul>
          <h3 className="c5" id="h.55qethhfbbyq">
            <span className="c3">Платежі</span>
          </h3>
          <p className="c1">
            <span className="c0">
              Ми можемо надавати платні продукти та / або послуги в межах Сервісу. У цьому випадку ми використовуємо
              послуги сторонніх виробників для обробки платежів (наприклад, процесори платежів).
            </span>
          </p>
          <p className="c1">
            <span className="c0">
              Ми не зберігатимемо та не збиратимемо деталі платіжної картки. Ця інформація надається безпосередньо нашим
              стороннім процесорам оплати, чиє використання вашої особистої інформації регулюється їх Політикою
              конфіденційності. Ці платіжні процесори дотримуються стандартів, встановлених PCI-DSS, якими керує Рада зі
              стандартів безпеки PCI, що є спільними зусиллями таких брендів, як Visa, MasterCard, American Express і
              Discover. Вимоги PCI-DSS забезпечують безпечну обробку платіжної інформації.
            </span>
          </p>
          <p className="c1">
            <span className="c0">Платіжні процесори, з якими ми працюємо, є:</span>
          </p>
          <ul className="c8 lst-kix_1aoi9a7elgdw-0 start">
            <li className="c1 c2">
              <span>
                Stripe
                <br />
                Їх Політика конфіденційності можна переглянути на{' '}
              </span>
              <span className="c12">
                <a
                  className="c16"
                  href="https://www.google.com/url?q=https://stripe.com/us/privacy&amp;sa=D&amp;ust=1562951790328000"
                >
                  https://stripe.com/us/privacy
                </a>
              </span>
            </li>
          </ul>
          <h2 className="c4" id="h.lpefkxtahlgl">
            <span className="c9">Посилання на інші сайти</span>
          </h2>
          <p className="c1">
            <span className="c0">
              Наш Сервіс може містити посилання на інші сайти, які не керуються нами. Якщо ви натискаєте посилання
              третьої сторони, вас буде направлено на сайт третьої сторони. Ми настійно рекомендуємо переглянути
              політику конфіденційності кожного сайту, який ви відвідуєте.
            </span>
          </p>
          <p className="c1">
            <span className="c0">
              Ми не контролюємо і не несемо відповідальності за зміст, політику конфіденційності або практику будь-яких
              сайтів або послуг третіх сторін.
            </span>
          </p>
          <h2 className="c4" id="h.fx35tw6ir79f">
            <span className="c9">Конфіденційність для дітей</span>
          </h2>
          <p className="c1">
            <span className="c0">Наш сервіс не стосується осіб, які досягли 18-річного віку ("Діти").</span>
          </p>
          <p className="c1">
            <span className="c0">
              Ми не свідомо збираємо особисту інформацію від осіб, які досягли 18-річного віку. Якщо ви є батьком або
              опікуном і знаєте, що ваша дитина надала нам особисті дані, будь ласка, зв'яжіться з нами. Якщо ми
              дізнаємося, що ми збирали особисті дані від дітей без підтвердження згоди батьків, ми вживаємо заходів для
              видалення цієї інформації з наших серверів.
            </span>
          </p>
          <h2 className="c4" id="h.5hl9mr2n7k7s">
            <span className="c9">Зміни до цієї політики конфіденційності</span>
          </h2>
          <p className="c1">
            <span className="c0">
              Ми можемо час від часу оновлювати нашу політику конфіденційності. Ми повідомимо вас про будь-які зміни,
              розмістивши на цій сторінці нову політику конфіденційності.
            </span>
          </p>
          <p className="c1">
            <span className="c0">
              Ми повідомимо вам електронною поштою та / або помітним повідомленням про наш Сервіс до того, як зміна
              стане ефективною та оновить "дату набуття чинності" у верхній частині цієї політики конфіденційності.
            </span>
          </p>
          <p className="c1">
            <span className="c0">
              Рекомендується періодично переглядати цю Політику конфіденційності для внесення будь-яких змін. Зміни до
              цієї Політики конфіденційності є ефективними, коли вони розміщені на цій сторінці.
            </span>
          </p>
          <h2 className="c4" id="h.wfbg6cbe1g9w">
            <span className="c9">Зв'яжіться з нами</span>
          </h2>
          <p className="c1">
            <span className="c0">
              Якщо у вас виникли питання щодо цієї політики конфіденційності, будь ласка, зв'яжіться з нами за допомогою
              електронної пошти support@voopty.com
            </span>
          </p>
          <p className="c1 c6">
            <span className="c0"></span>
          </p>
          <p className="c1 c6">
            <span className="c0"></span>
          </p>
          <p className="c1 c6">
            <span className="c0"></span>
          </p>
        </div>
      );
    case 'ru_UA':
      return (
        <div style={{ margin: 10 }}>
          <h1 className="c10" id="h.nqwmglxlm3ih">
            <span className="c13">Политика конфиденциальности</span>
          </h1>
          <p className="c3">
            <span className="c0">Дата вступления в силу: 16 июня 2019</span>
          </p>
          <p className="c3 c7">
            <span className="c0"></span>
          </p>
          <p className="c3">
            <span className="c0">
              Voopty ( «мы», «мы», или «наш») работает на сайте https://www.voopty.com/ (далее - "Сервис").
            </span>
          </p>
          <p className="c3">
            <span className="c0">
              Эта страница информирует Вас о нашей политике по сбору, использования и раскрытия персональных данных при
              использовании услуг нашим Сервисом, и выбор, связанный с этими данными.
            </span>
          </p>
          <p className="c3">
            <span>
              Мы используем ваши данные для предоставления и улучшения Сервиса. Пользуясь услугой, вы соглашаетесь на
              сбор и использование информации в соответствии с этой политикой. Если в этой Политике конфиденциальности
              не определен другое, термины, используемые в настоящей Политике конфиденциальности, имеют такие же
              значения, как и в наших общих положениях и условиях, доступных по адресу{' '}
            </span>
            <span>https://www.voopty.com/</span>
          </p>
          <h2 className="c4" id="h.fx3y36r1zii7">
            <span className="c1">Определение</span>
          </h2>
          <ul className="c5 lst-kix_rskoezreub4b-0 start">
            <li className="c2">
              <span className="c0">Сервис - это https : //www.voopty .com / веб-сайт, управляемый Voopty</span>
            </li>
            <li className="c2">
              <span className="c0">
                Личные данные - это данные о живой лицо, может быть идентифицирована из этих данных (или тех и других
                сведений, которые есть в нашем распоряжении или могут быть у нас в собственности).
              </span>
            </li>
            <li className="c2">
              <span className="c0">
                Данные об использовании - это данные, которые собираются автоматически или с использованием Сервиса, или
                же сервисной инфраструктуры (например, продолжительность посещения страницы).
              </span>
            </li>
            <li className="c2">
              <span className="c0">
                Cookies - это небольшие файлы, хранящиеся на устройстве (компьютере или мобильном устройстве).
              </span>
            </li>
            <li className="c2">
              <span className="c0">
                Контроллер данных - физическое или юридическое лицо, (самостоятельно или совместно с другими лицами)
                определяет цели и способ, в котором любая личная информация обрабатывается, или должна быть обработана.
                <br />
                Для целей настоящей Политики конфиденциальности мы контроллером данных Ваших персональных данных.
              </span>
            </li>
            <li className="c2">
              <span className="c0">
                Обработчик данных (или поставщик услуг) означает любое физическое или юридическое лицо, обрабатывает
                данные от имени контроллера данных.
                <br />
                Мы можем использовать услуги различных поставщиков услуг для более эффективной обработки ваших данных.
              </span>
            </li>
            <li className="c2">
              <span className="c0">
                Субъект данных (или Пользователь) - это любое живое лицо, пользующееся нашей услугой и предмет
                персональных данных.
              </span>
            </li>
          </ul>
          <h2 className="c4" id="h.5xocmgqoiq64">
            <span className="c1">Сбор информации и использование</span>
          </h2>
          <p className="c3">
            <span className="c0">
              Мы собираем несколько различных типов информации для различных целей, чтобы предоставить и улучшить наш
              сервис для Вас.
            </span>
          </p>
          <h3 className="c9" id="h.amhj33b2c5i9">
            <span className="c6">Типы собранных данных</span>
          </h3>
          <h4 className="c8" id="h.n11jofm5p55j">
            <span className="c16">Личные данные</span>
          </h4>
          <p className="c3">
            <span className="c0">
              При использовании нашим Сервисом, мы можем попросить Вас предоставить нам определенную личную информацию,
              которая может быть использована для связи или идентификации ( "Личные данные"). Информация,
              идентифицирующая личность, может включать, но не ограничиваться следующим:
            </span>
          </p>
          <p className="c3 c7">
            <span className="c0"></span>
          </p>
          <ul className="c5 lst-kix_nmr2jirr64ll-0 start">
            <li className="c2">
              <span className="c0">Адрес электронной почты</span>
            </li>
            <li className="c2">
              <span className="c0">Имя и фамилия</span>
            </li>
            <li className="c2">
              <span className="c0">Номер телефона</span>
            </li>
            <li className="c2">
              <span className="c0">Адрес, штат, провинция, ZIP / Почтовый код Город</span>
            </li>
            <li className="c2">
              <span className="c0">Cookies и данные об использовании</span>
            </li>
          </ul>
          <p className="c3 c7">
            <span className="c0"></span>
          </p>
          <p className="c3">
            <span className="c0">
              Мы можем использовать ваши личные данные, чтобы н "Связаться с вами с помощью информационных бюллетеней,
              маркетинговых материалов с целью предоставить информацию, которая может вас заинтересовать. Вы можете
              отказаться от получения любых, или всех этих сообщений от нас, обратившись к нам.
            </span>
          </p>
          <h4 className="c8" id="h.pvn88gc78nme">
            <span className="c16">Данные об использовании</span>
          </h4>
          <p className="c3">
            <span className="c0">
              Мы можем собирать информацию о доступе к Сервису и ее использования ( "данные об использовании"). Эти
              данные об использовании могут содержать такую информацию, как адрес Интернет-протокола компьютера
              (например, IP-адрес), тип браузера, версия барузер, страницы нашего Сервиса, которые вы посещаете, время и
              дату вашего посещения, время, затраченное на эти страницы, уникальный идентификаторы устройств и другие
              диагностические данные.
            </span>
          </p>
          <h4 className="c8" id="h.r5d2p3uqjgvn">
            <span className="c16">Данные о местонахождении</span>
          </h4>
          <p className="c3">
            <span className="c0">
              Мы можем использовать и хранить информацию о местоположении, если вы даете нам разрешение на это ( "данные
              о местонахождении»). Мы используем эти данные для обеспечения функций нашего Сервиса, для улучшения и
              настройки нашего Сервиса.
            </span>
          </p>
          <p className="c3">
            <span className="c0">
              Можно включать или выключать сервисы определения местоположения, когда вы пользуетесь нашим Сервисом в
              любое время с помощью настроек устройства.
            </span>
          </p>
          <h4 className="c8" id="h.mi0p5721elhc">
            <span className="c16">Отслеживание и данные cookie</span>
          </h4>
          <p className="c3">
            <span className="c0">
              Мы используем файлы cookie и подобные технологии отслеживания для отслеживания деятельности нашего Сервиса
              и сохраняем определенную информацию.
            </span>
          </p>
          <p className="c3">
            <span className="c0">
              Cookies - это файлы с небольшим количеством данных, которые могут включать анонимный уникальный
              идентификатор. Файлы cookie направляются в браузере с сайта и хранятся на устройстве. Также используются
              другие технологии отслеживания, такие как маяки, теги и скрипты для сбора и отслеживания информации, а
              также для совершенствования и анализа нашего Сервиса.
            </span>
          </p>
          <p className="c3">
            <span className="c0">
              Вы можете отказаться от всех файлов cookie или указать, когда направляется файл cookie, вказвшы
              соответствующие настройки своего браузера. Однако, если вы не принимаете файлы cookie, вы не сможете
              использовать некоторые части нашего Сервиса.
            </span>
          </p>
          <p className="c3">
            <span className="c0">Примеры файлов cookie, которые мы используем:</span>
          </p>
          <ul className="c5 lst-kix_c2t6h8m0hunk-0 start">
            <li className="c2">
              <span className="c11">Session Cookies.</span>
              <span className="c0">&nbsp;Мы используем Session Cookies для управления нашим Сервисом.</span>
            </li>
            <li className="c2">
              <span className="c11">Preference Cookies.</span>
              <span className="c0">
                &nbsp;Мы используем Preference Cookies для запоминания Ваших предпочтений и различных параметров.
              </span>
            </li>
            <li className="c2">
              <span className="c11">Security Cookies.</span>
              <span className="c0">&nbsp;Мы используем Security Cookies для целей безопасности.</span>
            </li>
          </ul>
          <h2 className="c4" id="h.5jlvpqhhfp9i">
            <span className="c1">Использование данных</span>
          </h2>
          <p className="c3">
            <span className="c0">Voopty использует собранные данные для разных целей:</span>
          </p>
          <ul className="c5 lst-kix_q1t6q3ncm7z8-0 start">
            <li className="c2">
              <span className="c0">предоставление и поддержка нашего Сервиса;</span>
            </li>
            <li className="c2">
              <span className="c0">Чтобы сообщить Вам об изменениях в нашем Сервисе;</span>
            </li>
            <li className="c2">
              <span className="c0">
                И позволяет участвовать в интерактивных функциях нашего Сервиса, когда Вы решите сделать это;
              </span>
            </li>
            <li className="c2">
              <span className="c0">Чтобы обеспечить поддержку клиентов;</span>
            </li>
            <li className="c2">
              <span className="c0">
                Чтобы собрать анализ или ценную информацию, чтобы мы могли улучшить наш Сервис;
              </span>
            </li>
            <li className="c2">
              <span className="c0">Чтобы контролировать использование нашего Сервиса;</span>
            </li>
            <li className="c2">
              <span className="c0">Для выявления, предотвращения и разрешения технических вопросов;</span>
            </li>
            <li className="c2">
              <span className="c0">
                Чтобы предоставить вам новости, специальные предложения и общую информацию о других товарах, услугах и
                события, которые мы предлагаем, подобные тем, которые вы уже приобрели или спросили, в том случае, если
                вы не выбрали ранее не получать такую информацию.
              </span>
            </li>
          </ul>
          <h2 className="c4" id="h.cqsdzp1v16vs">
            <span className="c1">
              Правовая основа для обработки персональных данных в соответствии с Общего регламента по защите данных
              (GDPR)
            </span>
          </h2>
          <p className="c3">
            <span className="c0">
              Если вы находитесь с Европейской Экономической Зоне (ЕЭЗ), правовая база для сбора использования личной
              информации, описанной в этой Политике конфиденциальности, зависит от личных данных, которые мы собираем, и
              конкретного контекста, в котором мы собираемся выкладывайте его.
            </span>
          </p>
          <p className="c3">
            <span className="c0">Voopty может обрабатывать ваши личные данные потому что:</span>
          </p>
          <ul className="c5 lst-kix_s4lko0wzby03-0 start">
            <li className="c2">
              <span className="c0">мы должны выполнить контракт с вами;</span>
            </li>
            <li className="c2">
              <span className="c0">вы предоставили нам разрешение сделать это;</span>
            </li>
            <li className="c2">
              <span className="c0">обработка в наших законных интересах и не переопределена правами;</span>
            </li>
            <li className="c2">
              <span className="c0">для целей обработки платежей;</span>
            </li>
            <li className="c2">
              <span className="c0">с целью соблюдения закона.</span>
            </li>
          </ul>
          <h2 className="c4" id="h.sc3aqa1afgeg">
            <span className="c1">Содержание данных</span>
          </h2>
          <p className="c3">
            <span className="c0">
              Voopty хранить Ваши Персональные Данные только в течение времени, необходимого для целей, изложенных в
              настоящей Политике конфиденциальности. Мы будем сохранять и использовать Ваши Персональные Данные в
              пределах, необходимых для выполнения наших юридических обязательств (например, если мы должны сохранить
              Ваши данные для соблюдения действующего законодательства), решить споры и обеспечить выполнение наших
              юридических соглашений и политик.
            </span>
          </p>
          <p className="c3">
            <span className="c0">
              Voopty также сохранять данные об использовании для целей внутреннего анализа. Данные об использовании
              обычно сохраняются в течение более короткого периода времени, за исключением случаев, когда эти данные
              используются для усиления безопасности или для улучшения функциональности нашего Сервиса, или мы
              юридически обязаны хранить эти данные на более длительное время.
            </span>
          </p>
          <h2 className="c4" id="h.nnnk0m34a01c">
            <span className="c1">Передача данных</span>
          </h2>
          <p className="c3">
            <span className="c0">
              Ваша информация, включая личные данные, может быть передана на компьютеры, расположенные за пределами
              вашей страны, провинции, страны или другой правительственной юрисдикции и храниться на них, когда законы о
              защите данных могут отличаться от законов вашей юрисдикции.
            </span>
          </p>
          <p className="c3">
            <span className="c0">
              Если вы находитесь за пределами Соединенных Штатов и предоставляете нам информацию, обратите внимание, что
              мы передаем данные, включая личные данные, в Соединенные Штаты и обрабатываем их там.
            </span>
          </p>
          <p className="c3">
            <span className="c0">
              Ваше согласие на эту политику конфиденциальности, по которой вы подаете такую информацию, является ваше
              согласие на эту передачу.
            </span>
          </p>
          <p className="c3">
            <span className="c0">
              Компания Voopty будет принимать все необходимые меры для обеспечения надежной обработки Ваших данных и в
              соответствии с этой политикой конфиденциальности, а перенос Ваших персональных данных не произойдет в
              организацию или страну, если не будет обеспечен надлежащий контроль, включая безопасность данные и другую
              личную информацию.
            </span>
          </p>
          <h2 className="c4" id="h.y3uf71x29l1">
            <span className="c1">Раскрытие информации о</span>
          </h2>
          <h3 className="c9" id="h.tltfafywcenw">
            <span className="c6">бизнес-операции</span>
          </h3>
          <p className="c3">
            <span className="c0">
              Если компания Voopty участвующего в слиянии, приобретении или продаже активов, ваши личные данные могут
              быть переданы. Мы вышлем сообщение до того, как Ваши Персональные Данные будут переданы и станут предметом
              другой политики конфиденциальности.
            </span>
          </p>
          <h3 className="c9" id="h.oni31inuh9mi">
            <span className="c6">Раскрытие информации для правоохранительных органов</span>
          </h3>
          <p className="c3">
            <span className="c0">
              При определенных обстоятельствах, Voopty может требовать раскрытия Ваших персональных данных, если это
              требуется законом или в ответ на действительные запросы органов государственной власти (например, суд или
              государственный орган).
            </span>
          </p>
          <h3 className="c9" id="h.nc9f4bkdqtmy">
            <span className="c6">Юридические требования</span>
          </h3>
          <p className="c3">
            <span className="c0">
              Voopty может раскрыть ваши личные данные в добросовестном припущеннитещо такое действие необходимо:
            </span>
          </p>
          <ul className="c5 lst-kix_50hpoaxqw86w-0 start">
            <li className="c2">
              <span className="c0">В соответствии с юридическим обязательством</span>
            </li>
            <li className="c2">
              <span className="c0">защищать и отстаивать права или собственность Voopty</span>
            </li>
            <li className="c2">
              <span className="c0">Для предотвращения и расследования возможных нарушений в связи с Сервисом</span>
            </li>
            <li className="c2">
              <span className="c0">чтобы защитить личную безопасность пользователей Сервиса, или общественности</span>
            </li>
            <li className="c2">
              <span className="c0">Защита от юридической ответственности</span>
            </li>
          </ul>
          <h2 className="c4" id="h.tq23cwoanl8b">
            <span className="c1">Безопасность данных</span>
          </h2>
          <p className="c3">
            <span className="c0">
              Безопасность Ваших данных важна для нас, но помните, что ни один способ передачи через Интернет или метод
              электронного хранения не является 100% безопасным. Хотя мы стремимся использовать коммерчески приемлемые
              средства для защиты ваших личных данных, мы не можем гарантировать его абсолютную безопасность.
            </span>
          </p>
          <h2 className="c4" id="h.8s1dmn35btsh">
            <span className="c1">
              Наша политика в отношении сигналов «Не отслеживать" по закону о защите онлайн (CalOPPA) в Калифорнии
            </span>
          </h2>
          <p className="c3">
            <span className="c0">
              Мы не поддерживаем Do Not Track ( "DNT"). НЕ отслеживать - это преимущества, которые можно установить в
              браузере, чтобы сообщить веб-сайты, которые вы не хотите отслеживать.
            </span>
          </p>
          <p className="c3">
            <span className="c0">
              Можно включить или выключить функцию «Не отслеживать", перейдя на страницу "Настройки" или "Настройка"
              браузера.
            </span>
          </p>
          <h2 className="c4" id="h.z43fl9ctsazm">
            <span className="c1">Права на защиту данных в соответствии с Регламентом общей защиты данных (GDPR)</span>
          </h2>
          <p className="c3">
            <span className="c0">
              Если вы являетесь резидентом Европейской экономической зоны (ЕЭЗ), у вас есть определенные права защиты
              данных. Компания Voopty стремится принять разумные меры, чтобы позволить вам исправить, изменить, удалить
              или ограничить использование Ваших персональных данных.
            </span>
          </p>
          <p className="c3">
            <span className="c0">
              Если вы хотите быть в курсе того, что личные данные, которые мы храним о вас, и если вы хотите, чтобы они
              были удалены из наших систем, пожалуйста, свяжитесь с нами.
            </span>
          </p>
          <p className="c3">
            <span className="c0">При определенных обстоятельствах вы такие права защиты данных:</span>
          </p>
          <ul className="c5 lst-kix_3h7w6h6l2vfu-0 start">
            <li className="c2">
              <span className="c0">
                право на доступ, обновление или удаление информации, которую мы имеем о вас. Когда это станет возможным,
                вы можете получить доступ, обновить или подать запрос на удаление ваших личных данных непосредственно в
                разделе настроек учетной записи. Если вы не можете выполнить эти действия самостоятельно, свяжитесь с
                нами, чтобы помочь вам.
              </span>
            </li>
            <li className="c2">
              <span className="c0">
                Право на исправление. Вы имеете право на исправление вашей информации, если эта информация является
                неточной или неполной.
              </span>
            </li>
            <li className="c2">
              <span className="c0">Право на объект. Вы имеете право отрицать нашу обработку ваших личных данных.</span>
            </li>
            <li className="c2">
              <span className="c0">
                Право ограничения. Вы имеете право требовать, чтобы мы ограничили обработку вашей личной информации.
              </span>
            </li>
            <li className="c2">
              <span className="c0">
                Право на портативность данных. Вы имеете право получить копию информации, которую мы имеем о вас, в
                структурированном, машиночитаемом и широко используемом формате.
              </span>
            </li>
            <li className="c2">
              <span className="c0">
                Право на отзыв согласия. Вы также имеете право отозвать свое согласие в любое время, когда Voopty
                возлагается на ваше согласие на обработку ваших персональных данных.
              </span>
            </li>
          </ul>
          <p className="c3">
            <span className="c0">
              Заметьте, что мы можем попросить вас подтвердить свою личность, прежде чем отвечать на такие запросы.
            </span>
          </p>
          <p className="c3">
            <span className="c0">
              Вы имеете право подать жалобу в орган защиты данных о нашей сбор и использование Ваших персональных
              данных. Для получения дополнительной информации обратитесь в местный орган защиты данных в Европейской
              экономической зоне (ЕЭЗ).
            </span>
          </p>
          <h2 className="c4" id="h.vt4esr5b88hn">
            <span className="c1">Поставщики услуг</span>
          </h2>
          <p className="c3">
            <span className="c0">
              Мы можем привлекать компании и физических лиц третьих лиц для содействия нашем Сервиса ( "поставщики
              услуг"), предоставлять Сервис от нашего имени, выполнять услуги, связанные с обслуживанием, или помогать
              нам в анализе использования Сервиса.
            </span>
          </p>
          <p className="c3">
            <span className="c0">
              Эти третьи стороны имеют доступ к Вашим персональных данных только для выполнения этих задач от нашего
              имени и обязаны не разглашать или использовать ее для любых других целей.
            </span>
          </p>
          <h3 className="c9" id="h.rqoneltegftt">
            <span className="c6">Аналитика</span>
          </h3>
          <p className="c3">
            <span className="c0">
              Мы можем использовать поставщиков услуг третьей стороны для мониторинга и анализа использования нашего
              Сервиса.
            </span>
          </p>
          <ul className="c5 lst-kix_8324hhdwt53y-0 start">
            <li className="c2">
              <span>
                Google Analytics
                <br />
                Google Analytics- это сервис веб-аналитики, которая предлагает Google, которая отслеживает и сообщает о
                трафике сайта. Google использует собранные данные для отслеживания и контроля использования нашего
                Сервиса. Эти данные предоставляются совместно с другими сервисами Google. Google может использовать
                собранные данные для контекстуализации и персонализации объявлений собственной рекламной сети.
                <br />
                Вы можете отказаться от того, что ваша деятельность в Сервисе доступна для Google Analytics, установив
                дотаток к браузеру Google Analytics opt-out. Это приложение запрещает JavaScript Analytics (ga.js,
                analytics.js и dc.js) обмениваться информацией с Google Analytics по активности посещений.
                <br />
                Дополнительную информацию о политике Google конфиденциальности на веб-страницу Политики
                конфиденциальности и условий Google:{' '}
              </span>
              <span className="c12">
                <a
                  className="c14"
                  href="https://www.google.com/url?q=https://policies.google.com/privacy?hl%3Den&amp;sa=D&amp;ust=1562952622226000"
                >
                  https://policies.google.com/privacy?hl=uk
                </a>
              </span>
            </li>
          </ul>
          <h3 className="c9" id="h.55qethhfbbyq">
            <span className="c6">Платежи</span>
          </h3>
          <p className="c3">
            <span className="c0">
              Мы можем предоставлять платные продукты и / или услуги в пределах Сервиса. В этом случае мы используем
              услуги сторонних производителей для обработки платежей (например, процессоры платежей).
            </span>
          </p>
          <p className="c3">
            <span className="c0">
              Мы не будем сохранять но не собирать сведения о платежной карте. Эта информация предоставляется
              непосредственно нашим сторонним процессорам оплаты, чье использование вашей личной информации регулируется
              их Политикой конфиденциальности. Эти платежные процессоры придерживаются стандартов, установленных
              PCI-DSS, которыми руководит Совет по стандартам безопасности PCI, являются общими усилиями таких брендов,
              как Visa, MasterCard, American Express и Discover. Требования PCI-DSS обеспечивают безопасную обработку
              платежной информации.
            </span>
          </p>
          <p className="c3">
            <span className="c0">Платежные процессоры, с которыми мы работаем, являются:</span>
          </p>
          <ul className="c5 lst-kix_1aoi9a7elgdw-0 start">
            <li className="c2">
              <span>
                Stripe
                <br />
                Их Политика конфиденциальности можно посмотреть на{' '}
              </span>
              <span className="c12">
                <a
                  className="c14"
                  href="https://www.google.com/url?q=https://stripe.com/us/privacy&amp;sa=D&amp;ust=1562952622227000"
                >
                  https://stripe.com/us/privacy
                </a>
              </span>
            </li>
          </ul>
          <h2 className="c4" id="h.lpefkxtahlgl">
            <span className="c1">Ссылки на другие сайты</span>
          </h2>
          <p className="c3">
            <span className="c0">
              Наш Сервис может содержать ссылки на другие сайты, не руководствуются нами. Если вы нажимаете ссылку
              третьей стороны, вас будут направлены на сайт третьей стороны. Мы настоятельно рекомендуем пересмотреть
              политику конфиденциальности каждого сайта, который вы посещаете.
            </span>
          </p>
          <p className="c3">
            <span className="c0">
              Мы не контролируем и не несем ответственности за содержание, политику конфиденциальности или практику
              любых сайтов или услуг третьих сторон.
            </span>
          </p>
          <h2 className="c4" id="h.fx35tw6ir79f">
            <span className="c1">Конфиденциальность для детей</span>
          </h2>
          <p className="c3">
            <span className="c0">Наш сервис не касается лиц, достигших 18-летнего возраста ( "Дети").</span>
          </p>
          <p className="c3">
            <span className="c0">
              Мы не сознательно собираем личную информацию от лиц, достигших 18-летнего возраста. Если вы являетесь
              родителем или опекуном и знаете, что ваш ребенок предоставила нам личные данные, пожалуйста, свяжитесь с
              нами. Если мы узнаем, что мы собирали личные данные от детей без подтверждения согласия родителей, мы
              принимаем меры для удаления этой информации из наших серверов.
            </span>
          </p>
          <h2 className="c4" id="h.5hl9mr2n7k7s">
            <span className="c1">Изменения в этой политики конфиденциальности</span>
          </h2>
          <p className="c3">
            <span className="c0">
              Мы можем время от времени обновлять нашу политику конфиденциальности. Мы сообщим вам о любых изменениях,
              разместив на этой странице новую политику конфиденциальности.
            </span>
          </p>
          <p className="c3">
            <span className="c0">
              Мы сообщим вам по электронной почте и / или заметным сообщением о нашем Сервис до того, как изменение
              станет эффективной и обновит "дату вступления в силу" в верхней части этой политики конфиденциальности.
            </span>
          </p>
          <p className="c3">
            <span className="c0">
              Рекомендуется периодически просматривать эту Политику конфиденциальности для внесения каких-либо
              изменений. Изменения в этой Политики конфиденциальности эффективны, когда они размещены на этой странице.
            </span>
          </p>
          <h2 className="c4" id="h.wfbg6cbe1g9w">
            <span className="c1">Свяжитесь с нами</span>
          </h2>
          <p className="c3">
            <span className="c0">
              Если у вас возникли вопросы по данной политики конфиденциальности, пожалуйста, свяжитесь с нами по
              электронной почте support@voopty.com
            </span>
          </p>
          <p className="c3 c7">
            <span className="c0"></span>
          </p>
          <p className="c3 c7">
            <span className="c0"></span>
          </p>
          <p className="c3 c7">
            <span className="c0"></span>
          </p>
        </div>
      );
  }
  return (
    <div style={{ margin: 10 }}>
      <h1>Privacy Policy</h1>

      <p>Effective date: June 16, 2019</p>

      <p>
        Voopty ("us", "we", or "our") operates the https://www.voopty.com/ website (hereinafter referred to as the
        "Service").
      </p>

      <p>
        This page informs you of our policies regarding the collection, use and disclosure of personal data when you use
        our Service and the choices you have associated with that data.
      </p>

      <p>
        We use your data to provide and improve the Service. By using the Service, you agree to the collection and use
        of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used
        in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible from
        https://www.voopty.com/
      </p>

      <h2>Definitions</h2>
      <ul>
        <li>
          <p>
            <strong>Service</strong>
          </p>
          <p>Service is the https://www.voopty.com/ website operated by Voopty</p>
        </li>
        <li>
          <p>
            <strong>Personal Data</strong>
          </p>
          <p>
            Personal Data means data about a living individual who can be identified from those data (or from those and
            other information either in our possession or likely to come into our possession).
          </p>
        </li>
        <li>
          <p>
            <strong>Usage Data</strong>
          </p>
          <p>
            Usage Data is data collected automatically either generated by the use of the Service or from the Service
            infrastructure itself (for example, the duration of a page visit).
          </p>
        </li>
        <li>
          <p>
            <strong>Cookies</strong>
          </p>
          <p>Cookies are small files stored on your device (computer or mobile device).</p>
        </li>
        <li>
          <p>
            <strong>Data Controller</strong>
          </p>
          <p>
            Data Controller means the natural or legal person who (either alone or jointly or in common with other
            persons) determines the purposes for which and the manner in which any personal information are, or are to
            be, processed.
          </p>
          <p>For the purpose of this Privacy Policy, we are a Data Controller of your Personal Data.</p>
        </li>
        <li>
          <p>
            <strong>Data Processors (or Service Providers)</strong>
          </p>
          <p>
            Data Processor (or Service Provider) means any natural or legal person who processes the data on behalf of
            the Data Controller.
          </p>
          <p>We may use the services of various Service Providers in order to process your data more effectively.</p>
        </li>
        <li>
          <p>
            <strong>Data Subject (or User)</strong>
          </p>
          <p>Data Subject is any living individual who is using our Service and is the subject of Personal Data.</p>
        </li>
      </ul>

      <h2>Information Collection and Use</h2>
      <p>
        We collect several different types of information for various purposes to provide and improve our Service to
        you.
      </p>

      <h3>Types of Data Collected</h3>

      <h4>Personal Data</h4>
      <p>
        While using our Service, we may ask you to provide us with certain personally identifiable information that can
        be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is
        not limited to:
      </p>

      <ul>
        <li>Email address</li>
        <li>First name and last name</li>
        <li>Phone number</li>
        <li>Address, State, Province, ZIP/Postal code, City</li>
        <li>Cookies and Usage Data</li>
      </ul>

      <p>
        We may use your Personal Data to contact you with newsletters, marketing or promotional materials and other
        information that may be of interest to you. You may opt out of receiving any, or all, of these communications
        from us by contacting us.
      </p>

      <h4>Usage Data</h4>

      <p>
        We may also collect information on how the Service is accessed and used ("Usage Data"). This Usage Data may
        include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser
        version, the pages of our Service that you visit, the time and date of your visit, the time spent on those
        pages, unique device identifiers and other diagnostic data.
      </p>

      <h4>Location Data</h4>
      <p>
        We may use and store information about your location if you give us permission to do so ("Location Data"). We
        use this data to provide features of our Service, to improve and customise our Service.
      </p>
      <p>
        You can enable or disable location services when you use our Service at any time by way of your device settings.
      </p>

      <h4>Tracking & Cookies Data</h4>
      <p>
        We use cookies and similar tracking technologies to track the activity on our Service and we hold certain
        information.
      </p>
      <p>
        Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent
        to your browser from a website and stored on your device. Other tracking technologies are also used such as
        beacons, tags and scripts to collect and track information and to improve and analyse our Service.
      </p>
      <p>
        You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you
        do not accept cookies, you may not be able to use some portions of our Service.
      </p>
      <p>Examples of Cookies we use:</p>
      <ul>
        <li>
          <strong>Session Cookies.</strong> We use Session Cookies to operate our Service.
        </li>
        <li>
          <strong>Preference Cookies.</strong> We use Preference Cookies to remember your preferences and various
          settings.
        </li>
        <li>
          <strong>Security Cookies.</strong> We use Security Cookies for security purposes.
        </li>
      </ul>

      <h2>Use of Data</h2>
      <p>Voopty uses the collected data for various purposes:</p>
      <ul>
        <li>To provide and maintain our Service</li>
        <li>To notify you about changes to our Service</li>
        <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
        <li>To provide customer support</li>
        <li>To gather analysis or valuable information so that we can improve our Service</li>
        <li>To monitor the usage of our Service</li>
        <li>To detect, prevent and address technical issues</li>
        <li>
          To provide you with news, special offers and general information about other goods, services and events which
          we offer that are similar to those that you have already purchased or enquired about unless you have opted not
          to receive such information
        </li>
      </ul>

      <h2>Legal Basis for Processing Personal Data under the General Data Protection Regulation (GDPR)</h2>
      <p>
        If you are from the European Economic Area (EEA), Voopty legal basis for collecting and using the personal
        information described in this Privacy Policy depends on the Personal Data we collect and the specific context in
        which we collect it.
      </p>
      <p>Voopty may process your Personal Data because:</p>
      <ul>
        <li>We need to perform a contract with you</li>
        <li>You have given us permission to do so</li>
        <li>The processing is in our legitimate interests and it is not overridden by your rights</li>
        <li>For payment processing purposes</li>
        <li>To comply with the law</li>
      </ul>

      <h2>Retention of Data</h2>
      <p>
        Voopty will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy
        Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations
        (for example, if we are required to retain your data to comply with applicable laws), resolve disputes and
        enforce our legal agreements and policies.
      </p>
      <p>
        Voopty will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a
        shorter period of time, except when this data is used to strengthen the security or to improve the functionality
        of our Service, or we are legally obligated to retain this data for longer periods.
      </p>

      <h2>Transfer of Data</h2>
      <p>
        Your information, including Personal Data, may be transferred to — and maintained on — computers located outside
        of your state, province, country or other governmental jurisdiction where the data protection laws may differ
        from those of your jurisdiction.
      </p>
      <p>
        If you are located outside United States and choose to provide information to us, please note that we transfer
        the data, including Personal Data, to United States and process it there.
      </p>
      <p>
        Your consent to this Privacy Policy followed by your submission of such information represents your agreement to
        that transfer.
      </p>
      <p>
        Voopty will take all the steps reasonably necessary to ensure that your data is treated securely and in
        accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organisation or
        a country unless there are adequate controls in place including the security of your data and other personal
        information.
      </p>

      <h2>Disclosure of Data</h2>
      <h3>Business Transaction</h3>
      <p>
        If Voopty is involved in a merger, acquisition or asset sale, your Personal Data may be transferred. We will
        provide notice before your Personal Data is transferred and becomes subject to a different Privacy Policy.
      </p>

      <h3>Disclosure for Law Enforcement</h3>
      <p>
        Under certain circumstances, Voopty may be required to disclose your Personal Data if required to do so by law
        or in response to valid requests by public authorities (e.g. a court or a government agency).
      </p>

      <h3>Legal Requirements</h3>
      <p>Voopty may disclose your Personal Data in the good faith belief that such action is necessary to:</p>
      <ul>
        <li>To comply with a legal obligation</li>
        <li>To protect and defend the rights or property of Voopty</li>
        <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
        <li>To protect the personal safety of users of the Service or the public</li>
        <li>To protect against legal liability</li>
      </ul>

      <h2>Security of Data</h2>
      <p>
        The security of your data is important to us but remember that no method of transmission over the Internet or
        method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect
        your Personal Data, we cannot guarantee its absolute security.
      </p>

      <h2>Our Policy on "Do Not Track" Signals under the California Online Protection Act (CalOPPA)</h2>
      <p>
        We do not support Do Not Track ("DNT"). Do Not Track is a preference you can set in your web browser to inform
        websites that you do not want to be tracked.
      </p>
      <p>You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.</p>

      <h2>Your Data Protection Rights under the General Data Protection Regulation (GDPR)</h2>
      <p>
        If you are a resident of the European Economic Area (EEA), you have certain data protection rights. Voopty aims
        to take reasonable steps to allow you to correct, amend, delete or limit the use of your Personal Data.
      </p>
      <p>
        If you wish to be informed about what Personal Data we hold about you and if you want it to be removed from our
        systems, please contact us.
      </p>
      <p>In certain circumstances, you have the following data protection rights:</p>
      <ul>
        <li>
          <p>
            <strong>The right to access, update or delete the information we have on you.</strong> Whenever made
            possible, you can access, update or request deletion of your Personal Data directly within your account
            settings section. If you are unable to perform these actions yourself, please contact us to assist you.
          </p>
        </li>
        <li>
          <p>
            <strong>The right of rectification.</strong> You have the right to have your information rectified if that
            information is inaccurate or incomplete.
          </p>
        </li>
        <li>
          <p>
            <strong>The right to object.</strong> You have the right to object to our processing of your Personal Data.
          </p>
        </li>
        <li>
          <p>
            <strong>The right of restriction.</strong> You have the right to request that we restrict the processing of
            your personal information.
          </p>
        </li>
        <li>
          <p>
            <strong>The right to data portability.</strong> You have the right to be provided with a copy of the
            information we have on you in a structured, machine-readable and commonly used format.
          </p>
        </li>
        <li>
          <p>
            <strong>The right to withdraw consent.</strong> You also have the right to withdraw your consent at any time
            where Voopty relied on your consent to process your personal information.
          </p>
        </li>
      </ul>
      <p>Please note that we may ask you to verify your identity before responding to such requests.</p>

      <p>
        You have the right to complain to a Data Protection Authority about our collection and use of your Personal
        Data. For more information, please contact your local data protection authority in the European Economic Area
        (EEA).
      </p>

      <h2>Service Providers</h2>
      <p>
        We may employ third party companies and individuals to facilitate our Service ("Service Providers"), provide the
        Service on our behalf, perform Service-related services or assist us in analysing how our Service is used.
      </p>
      <p>
        These third parties have access to your Personal Data only to perform these tasks on our behalf and are
        obligated not to disclose or use it for any other purpose.
      </p>

      <h3>Analytics</h3>
      <p>We may use third-party Service Providers to monitor and analyse the use of our Service.</p>
      <ul>
        <li>
          <p>
            <strong>Google Analytics</strong>
          </p>
          <p>
            Google Analytics is a web analytics service offered by Google that tracks and reports website traffic.
            Google uses the data collected to track and monitor the use of our Service. This data is shared with other
            Google services. Google may use the collected data to contextualise and personalise the ads of its own
            advertising network.
          </p>
          <p>
            You can opt-out of having made your activity on the Service available to Google Analytics by installing the
            Google Analytics opt-out browser add-on. The add-on prevents the Google Analytics JavaScript (ga.js,
            analytics.js and dc.js) from sharing information with Google Analytics about visits activity.
          </p>{' '}
          <p>
            For more information on the privacy practices of Google, please visit the Google Privacy & Terms web page:{' '}
            <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a>
          </p>
        </li>
      </ul>

      <h3>Payments</h3>
      <p>
        We may provide paid products and/or services within the Service. In that case, we use third-party services for
        payment processing (e.g. payment processors).
      </p>
      <p>
        We will not store or collect your payment card details. That information is provided directly to our third-party
        payment processors whose use of your personal information is governed by their Privacy Policy. These payment
        processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a
        joint effort of brands like Visa, MasterCard, American Express and Discover. PCI-DSS requirements help ensure
        the secure handling of payment information.
      </p>
      <p>The payment processors we work with are:</p>
      <ul>
        <li>
          <p>
            <strong>Stripe</strong>
          </p>
          <p>
            Their Privacy Policy can be viewed at{' '}
            <a href="https://stripe.com/us/privacy">https://stripe.com/us/privacy</a>
          </p>
        </li>
      </ul>

      <h2>Links to Other Sites</h2>
      <p>
        Our Service may contain links to other sites that are not operated by us. If you click a third party link, you
        will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site
        you visit.
      </p>
      <p>
        We have no control over and assume no responsibility for the content, privacy policies or practices of any third
        party sites or services.
      </p>

      <h2>Children's Privacy</h2>
      <p>Our Service does not address anyone under the age of 18 ("Children").</p>
      <p>
        We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a
        parent or guardian and you are aware that your Child has provided us with Personal Data, please contact us. If
        we become aware that we have collected Personal Data from children without verification of parental consent, we
        take steps to remove that information from our servers.
      </p>

      <h2>Changes to This Privacy Policy</h2>
      <p>
        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy
        Policy on this page.
      </p>
      <p>
        We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective
        and update the "effective date" at the top of this Privacy Policy.
      </p>
      <p>
        You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are
        effective when they are posted on this page.
      </p>

      <h2>Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us:</p>
      <ul>
        <li>By email: support@voopty.com</li>
      </ul>
    </div>
  );
});
